// Omnix/client/ui/TicketIndexView.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TicketIndexView extends ComponentBase {
    static styles = `
        .ticket-index-view { display: flex; flex-direction: column; height: 100%; }
        .index-header { padding: 0.75rem 1rem; border-bottom: 1px solid var(--bs-border-color); flex-shrink: 0; }
        .index-filters { padding: 0.5rem 1rem; border-bottom: 1px solid var(--bs-border-color); flex-shrink: 0; }
        .ticket-list { flex-grow: 1; overflow-y: auto; }
        .ticket-list-item {
            padding: 0.75rem 1rem;
            cursor: pointer;
            border-bottom: 1px solid var(--bs-border-color-translucent);
            transition: background-color 0.15s ease-in-out;
        }
        .ticket-list-item:hover { background-color: var(--bs-tertiary-bg); }
        .ticket-list-item.active {
            background-color: var(--bs-primary-bg-subtle);
            border-left: 3px solid var(--bs-primary);
            padding-left: calc(1rem - 3px);
        }
        .ticket-subject {
            font-weight: 500;
            color: var(--bs-emphasis-color);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .ticket-meta {
            font-size: 0.8rem;
            color: var(--bs-secondary-color);
            display: flex;
            justify-content: space-between;
            margin-top: 0.25rem;
        }
        .priority-badge {
            font-size: 0.7rem;
            font-weight: 600;
            padding: 0.1em 0.4em;
            border-radius: 0.25rem;
        }
        .priority-urgent { background-color: var(--bs-danger-bg-subtle); color: var(--bs-danger-text-emphasis); }
        .priority-high { background-color: var(--bs-warning-bg-subtle); color: var(--bs-warning-text-emphasis); }
        .priority-normal { background-color: var(--bs-info-bg-subtle); color: var(--bs-info-text-emphasis); }
        .priority-low { background-color: var(--bs-secondary-bg-subtle); color: var(--bs-secondary-text-emphasis); }
    `;


    constructor(config) {
        super(config);
        this.tickets = [];
        this.totalCount = 0;
        this.activeFilters = {};
        this.applyStyles();
    }

    async initAfterLogin() {
        await this.loadTickets();
    }

    async loadTickets() {
        try {
            const result = await this.appClient.rpcClient.call('TicketRpc.getData', {
                filter: this.activeFilters,
                sort: { updatedAt: -1 }
            });
            this.tickets = result.data || [];
            this.totalCount = result.totalCount || 0;
            this.render();
        } catch (error) {
            this.log.error("Failed to load tickets:", error);
        }
    }

    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'ticket-index-view';
        }
        this.container.innerHTML = `
            <div class="index-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">${this.t('Tickets')}</h5>
                <div class="btn-group btn-group-sm gap-2">
                    <button class="btn btn-outline-secondary" id="refresh-tickets-btn" title="${this.t('Refresh')}"><i class="bi bi-arrow-clockwise"></i></button>
                    <button class="btn btn-primary" id="new-ticket-btn"><i class="bi bi-plus-lg"></i></button>
                </div>
            </div>
            <div class="index-filters">
                <!-- Filter UI will go here -->
            </div>
            <div class="ticket-list list-group list-group-flush"></div>
        `;

        const listContainer = this.container.querySelector('.ticket-list');
        if (this.tickets.length === 0) {
            listContainer.innerHTML = `<div class="p-3 text-center text-muted">${this.t('No tickets found.')}</div>`;
        } else {
            this.tickets.forEach(ticket => {
                const item = document.createElement('div');
                item.className = 'ticket-list-item';
                item.dataset.ticketId = ticket._id;

                const priorityLabel = this.t(ticket.priority.charAt(0).toUpperCase() + ticket.priority.slice(1));
                const statusLabel = this.t(ticket.status.charAt(0).toUpperCase() + ticket.status.slice(1));

                item.innerHTML = `
                    <div class="ticket-subject">${ticket.subject}</div>
                    <div class="ticket-meta">
                        <span>#${ticket.ticketNumber} &middot; ${statusLabel}</span>
                        <span class="priority-badge priority-${ticket.priority}">${priorityLabel}</span>
                    </div>
                `;
                item.addEventListener('click', () => {
                    this.container.querySelectorAll('.ticket-list-item').forEach(el => el.classList.remove('active'));
                    item.classList.add('active');
                    this.emit('ticketSelected', { ticketId: ticket._id });
                });
                listContainer.appendChild(item);
            });
        }

        this.container.querySelector('#new-ticket-btn').addEventListener('click', () => this.emit('newTicket'));
        this.container.querySelector('#refresh-tickets-btn').addEventListener('click', () => this.loadTickets()); // --- ADD REFRESH HANDLER ---
        return this.container;
    }
}
